import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {RfiForm} from "./RfiForm";
import {getRfi, updateProjectRfi} from "../../../actions/rfis";

const RfiEdit = props => {
  const { rfi, projectid, onSubmit, onCancel } = props;
  return <Card title='Project Rfi Details' className={'edit-view'}>
    <RfiForm projectid={projectid} rfi={rfi} onCancel={onCancel} onSubmit={onSubmit}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => {
      let rfi = state.view.subview.data[props.match.params.rfiId];
      if (!rfi) return { loading: true };
      return { rfi: rfi.resource, projectid: props.match.params.id };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getRfi(props.match.params.id, props.match.params.rfiId)),
      onSubmit: (rfi) => {
        dispatch(updateProjectRfi(props.match.params.id, rfi));
        props.history.goBack();
      },
      onCancel: () => props.history.goBack()
    })
  ),
  withLoading
)(RfiEdit);



// WEBPACK FOOTER //
// ./src/components/Projects/Rfis/RfiEdit.js